import { Grid,Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Autocomplete, TextField } from '@mui/material'
import React, { Fragment, memo, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useStyle } from '../style'
import axios from 'axios'
import { setSnackbar } from '../../../../../components/hooks/snackBar/reducers'
import _ from 'lodash'
import { Helmet } from 'react-helmet-async'
import dayjs from 'dayjs'
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import moment from 'moment'
import * as XLSX from 'xlsx';
import SimCardDownloadOutlinedIcon from '@mui/icons-material/SimCardDownloadOutlined';

const GstReport = () => {
    const dispatch = useDispatch()
    const classes = useStyle()
    const [data,setData] = useState([])
    const outletName = localStorage.getItem('outlet_name')
    const outletId = localStorage.getItem('outlet_id')
    const fixedOutlet = { id: outletId, fullname: outletName };
    const [supplier, setSupplier] = useState([]);
    const roleId = localStorage.getItem("role_id")
    const[cust, setCust] = useState(null)
    const [dateLimit, setDateLimit] = useState({
      fromDate : moment().subtract(1, 'months').format(),
      toDate : moment().format()
    })
    function handleChange(e, name) {
      setDateLimit(prev=>({...prev,[name] : dayjs(e).format() }))
    }

    function getGstLedger (){
      const postData = {
        from_date:moment(dateLimit.fromDate).format('YYYY-MM-DD'),
        to_date:moment(dateLimit.toDate).format('YYYY-MM-DD'),
      }
        axios.post(`/v1/reports/outlet_sales/hsn/gstledger/${cust!==null ? cust.id : fixedOutlet.id}`,postData)
        .then(res=>{
          console.log(res.data)
            const  response  = res.data
            setData(res.data.outlet_sales)

        })
        .catch(err=>{
            console.log(err)
            dispatch(setSnackbar(true,'error',err.response.data.errors[0].message))
        })
    }
    function getSupplierData() {
      axios
        .get("/v1/outlet/list/1")
        .then((res) => {
          setSupplier(res.data);
          _.filter(res.data,val=>val.id== outletId).map(val=>setCust(val))
        })
        .catch((err) => {
          dispatch(setSnackbar(true, "error", err.response.data.error));
        });
    }
    function exportToExcel() {
      const wb = XLSX.utils.book_new();
      const wsData = data.map(item => [
        item.hsn,
        // item.amount,
        // item.amount === '' ? '' : item.amount / 2,
        // item.amount === '' ? '' : item.amount / 2,
        // item.igst_amt,
        // item.cess_amt,
        // item.total === "" ? "" : parseFloat(item.total).toFixed(2),
        parseFloat(item.amount).toFixed(0),
        parseFloat(item.gst_amt).toFixed(0) === '' ? "" : parseFloat(item.gst_amt / 2).toFixed(0),
        parseFloat(item.gst_amt).toFixed(0) === '' ? "" : parseFloat(item.gst_amt / 2).toFixed(0),
        parseFloat(item.igst_amt).toFixed(0),
        parseFloat(item.cess_amt).toFixed(0),
        parseFloat(item.amount + item.gst_amt + item.igst_amt +item.cess_amt).toFixed(0)  
      ]);
   
      const ws = XLSX.utils.aoa_to_sheet([
        [
          // 'Purchase', 
          // '',
          // '',
          // '',
          // '',
          // '',
          // '',
          'Sales', 
          '',
          '',
        ],
        [
          'HSN',
          // 'Cash',
          // 'SGST',
          // 'CGST',
          // 'IGST',
          // 'CESS',
          // 'Total',
          'Cash',
          'SGST',
          'CGST',
          'IGST',
          'CESS',
          'Total'
        ],
        ...wsData
      ]);
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
      XLSX.writeFile(wb, "Outlet Hsn Report.xlsx");
    }
    useEffect(() => {
      getSupplierData();
    }, []);
    console.log(data)
    useEffect(()=>{
        getGstLedger()
    },[dateLimit,cust])
  return (
<Fragment>
    <Helmet><title>Outlet Hsn Report</title></Helmet>
    <Typography variant='h6'>Outlet HSN Report</Typography>
    <Grid container spacing={2} className="p-2 pt-2">
    <Grid item md={3}>
          <Autocomplete 
            size="small"
            value={cust}
            options={supplier}
            onChange={(e,value)=>setCust(value)}
            getOptionLabel={option=>option.fullname}
            disabled={roleId != 1 && roleId != 2} 
            renderInput={(params) => <TextField {...params} label="Select Outlet"/>}
          />
        </Grid>
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "fromDate")}
              value={dayjs(dateLimit.fromDate)}
              format='DD-MM-YYYY'
              slotProps={{
                textField: {
                  size: "small",
                  label:'From',
                  style:{width : '100%'}
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "toDate")}
              value={dayjs(dateLimit.toDate)}
              format='DD-MM-YYYY'
              slotProps={{
                textField: {
                  size: "small",
                  label:'To',
                  style:{width : '100%'}
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
      </Grid>
      <Grid className='text-end my-2'>
    <Button onClick={exportToExcel} variant="outlined" > Export to Excel <SimCardDownloadOutlinedIcon /></Button>
      </Grid>
    <Grid className='flex'>
        <TableContainer className={classes.tblRoot}>
            <Table>
                <TableHead className={classes.tblHeader}>
                    <TableRow className={classes.tablrow}>
                        <TableCell sx={{borderLeft:`1px solid #ccc`}} className={classes.tblContentCell} colSpan={10} align='center'>Sales</TableCell>
                    </TableRow>
                    <TableRow className={classes.tablrow}>
                      <TableCell sx={{borderLeft:`1px solid #ccc`}}>Gst %</TableCell>
                        <TableCell  >HSN</TableCell>
                        <TableCell >Cash</TableCell>
                        <TableCell>SGST</TableCell>
                        <TableCell>CGST</TableCell>
                        <TableCell>IGST</TableCell>
                        <TableCell>CESS</TableCell>
                        <TableCell>Total Gst</TableCell>
                        <TableCell>Total Qty</TableCell>
                        <TableCell>Total Amount</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                          {data.length > 0 && _.map(data,(val, idx)=>(    
                     <TableRow className={classes.tablrow1} key={idx}>
                            <TableCell  sx={{borderLeft: `1px solid #ccc`,textAlign:"center !important"}}>{val.gst_per}</TableCell>
                            <TableCell>{val.hsn}</TableCell>
                            <TableCell>{parseFloat(val.amount).toFixed(0)}</TableCell>
                            <TableCell>{parseFloat(val.gst_amt / 2).toFixed(0)}</TableCell>
                            <TableCell>{parseFloat(val.gst_amt / 2).toFixed(0)}</TableCell>
                            <TableCell>{parseFloat(val.igst_amt).toFixed(0)}</TableCell>
                            <TableCell>{parseFloat(val.cess_amt).toFixed(0)}</TableCell>
                            <TableCell>{parseFloat(val.gst_amt).toFixed(0) }</TableCell>
                            <TableCell>{val.qty}</TableCell>
                            <TableCell sx={{textAlign:"right !important" , fontWeight:600}}>{parseFloat(val.amount + val.gst_amt + val.igst_amt +val.cess_amt).toFixed(0)}</TableCell>
                     </TableRow>
                        ))}
                </TableBody>
            </Table>
    
        </TableContainer>
    </Grid>
</Fragment>
  )
}

export default memo(GstReport)